
<template>
  <div id="mainNav" class="topNav" @mouseleave="navMouseleave()">
    <div class="navs">
      <div class="navLeft">
        <!-- <img src="@/common/images/nav/t409.png" alt="" /> -->
        <img class="logonImg" src="@/common/images/nav/4253@3x.png" alt="" />
      </div>
      <div class="navRight">
        <div class="r_t">
          中国证监会认证证券咨询机构（证书编号：ZX0118) | 投诉热线：0755-82298818
          | 服务热线：400-636-8688
        </div>
        <div class="r_b">
          <router-link
            @mouseover.native="navMousemove(item)"
            :class="item.is ? 'isme' : ''"
            v-for="item in rous"
            :key="item.name"
            :to="item.path"
            >{{ item.text }}</router-link
          >
        </div>
      </div>
    <div class="navigation">
      <div class="navigation_box">
        <div class="navBox" v-for="(item, indexs) in navList" :key="indexs">
          <span class="navBox_title" v-if="item.ColumnType">{{
            item.ColumnType.name
          }}</span>
          <span
            class="navBox_son"
            @click="links(item, index)"
            v-for="(nav, index) in item.products"
            :key="nav.id"
            :class="{ wenzi: linkIndex == nav.name ? true : false }"
            >{{ nav.name }}</span
          >
        </div>
      </div>
    </div>
    </div>

  </div>
</template>

<script>
import { l } from "@/utils/tool";
import { colunmList, productList, columnTypeList } from "@/api/topNav.js";
export default {
  name: "topNav",
  data() {
    return {
      linkIndex: "",
      rous: [
        {
          path: "/index",
          text: "首页",
          name: "index",
          is: false,
        },
        {
          path: "/productCenter",
          text: "产品中心",
          name: "productCenter",
          is: false,
        },
        {
          path: "/education",
          text: "财教中心",
          name: "education",
          is: false,
        },
        // {
        //   path: "/index",
        //   text: "下载中心",
        //   name: "index2",
        //   is: false,
        // },
        {
          path: "/investTeam",
          // path: "/education",
          text: "投研中心",
          name: "investTeam",
          is: false,
        },
        {
          path: "/information",
          text: "必读资讯",
          name: "information",
          is: false,
        },
        // {
        //   path: "/investCenter",
        //   text: "客服投诉",
        //   name: "investCenter",
        //   is: false,
        // },
        // {
        //   path: "/lawColumn",
        //   text: "打非专栏",
        //   name: "lawColumn",
        //   is: false,
        // },
        {
          path: "/about",
          text: "关于财富在线",
          name: "about",
          is: false,
        },
        {
          path: "/stockUniverse",
          text: "股宇宙数据库",
          name: "stockUniverse",
          is: false,
        },
      ],
      navList: [
        {
          title: "资讯金融",
          navSon: [
            {
              path: "/ddzb",
              text: "大德涨势周报",
              name: "ddzb",
              is: false,
            },
            {
              path: "/ztcl",
              text: "主题策略",
              name: "ztcl",
            },
            {
              path: "",
              text: "时报德宝",
              name: "",
            },
          ],
        },
        {
          title: "数据金融",
          navSon: [
            {
              path: "/stockUniverse",
              text: "股宇宙数据库",
              name: "stockUniverse",
            },
            {
              path: "/dxsf",
              text: "德讯算法",
              name: "dxsf",
            },
            {
              path: "/dxzg",
              text: "财富在线",
              name: "dxzg",
            },
          ],
        },
        {
          title: "教育金融",
          navSon: [
            {
              path: "/jys",
              text: "交易师",
              name: "jys",
            },
            {
              path: "",
              text: "德财商学院",
              name: "",
            },
          ],
        },
        {
          title: "投顾金融",
          navSon: [
            {
              path: "/ddjy",
              text: "大德精研",
              name: "ddjy",
            },
            {
              path: "/ddzs",
              text: "大德专属",
              name: "ddzs",
            },
            {
              path: "/zgds",
              text: "诊股大师",
              name: "zgds",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.selectf();
    this.jiazaiLy();
    // l(sessionStorage.getItem('linkIndex'));
    this.linkIndex = sessionStorage.getItem("linkIndex");
  },
  methods: {
    navMousemove(item) {
      //悬停导航栏
      let navigation = document.querySelector(".navigation");
      // let navigationBox = document.querySelector(".navigation_box");
      // console.log(navigation);
      if (item.text == "产品中心") {
        navigation.style.display = "block";

        // navigation.style.display = "flex";
      } else {
        navigation.style.display = "none";
      }
    },
    navMouseleave() {
      //离开导航栏
      let navigation = document.querySelector(".navigation");
      navigation.style.display = "none";
    },
    links(item, index) {
      // l(item,'ii');
      sessionStorage.setItem("linkIndex", item.products[index].name);
      this.linkIndex = item.products[index].name;

      if (item.products[index].name == " 股宇宙数据库") {
        this.$router.push("stockUniverse");
      } else {
        this.$router.push({
          path: "/ddzb",
          query: {
            name: item.products[index].name,
          },
        });
      }
    },
    jiazaiLy() {
      var rou = this.$route.name;
      var arr = this.rous;
      // this.linkIndex = rou; //产品中心子集
      l(rou, arr, "扣你");
      arr.map(function (item, index) {
        if (item.name != rou) {
          item.is = false;
        } else {
          item.is = true;
        }
        if (
          (rou == "B04_djzl" ||
            rou == "B05_gsdt" ||
            rou == "B08_cpyc" ||
            rou == "B10_xgsm") &&
          item.name == "about"
        ) {
          item.is = true;
        }
        if (rou == "informatDetail" && item.name == "information") {
          item.is = true;
        }
        if (rou == "lawcDetail" && item.name == "lawColumn") {
          item.is = true;
        }
        if (rou == "subjectVideo" && item.name == "education") {
          item.is = true;
        }
        if (rou == "teacherVideo" && item.name == "education") {
          item.is = true;
        }
        if (rou == "productCenter" && item.name == "productCenter") {
          //点击产品中心
          item.is = true;
          sessionStorage.setItem("linkIndex", "");
        }
        //产品中心子页面跳转
        let navs = [
          "ddzb",
          "ztcl",
          "dxsf",
          "dxzg",
          "jys",
          "ddjy",
          "ddzs",
          "zgds",
        ];
        if (navs.includes(rou) && item.name == "productCenter") {
          //点击产品中心下的子集
          item.is = true;
        }
        if (!navs.includes(rou)) {
          //点击产品中心之外的
          sessionStorage.setItem("linkIndex", "");
        }
        //股宇宙
        if (rou == "gyzxz" && item.name == "stockUniverse") {
          item.is = true;
        }
      });
    },
    selectf() {
      //初始加载数据
      columnTypeList({ status: 1 }).then((res) => {
        //头部栏目列表
        if (res.code == 200) {
          this.navList = res.data.list;

          // this.rous = res.data.list;
          // res.data.list.forEach((v) => {
          //   v.is = false;
          // });
          // this.jiazaiLy();
        }
      });
    },
  },
};
</script>
<style scoped>
.topNav {
  width: 100%;
  max-width: 1920px;
  /* margin: auto; */
  height: 100px;
  background: #fff;
  position: fixed;
  left: 50%;
  top: -11px;
  z-index: 100;
  border-bottom: 1px solid #EBEBEB;
  transform: translateX(-50%);
  /* margin-bottom: 10px; */
}
.navs {
  width: 1223px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
  /* justify-content: center; */
}
.wenzi {
  color: #de161e !important;
}

.navLeft {
  width: 210px;
  /* height: 100%; */
  display: flex;
  align-items: center;
  margin-top: 18.5px;
  margin-right: 54px;
  padding-top: 20px;
}
.navRight {
  width: 1125px;
  height: 100%;
  text-align: left;
}
.r_t {
  width: 100%;
  /* height: 44px;
  line-height: 44px; */
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #aeaeae;
  opacity: 1;
  padding-left: 134px;
    margin-top: 20px;
    margin-bottom: 7px;
}
.r_b {
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  /* padding-left: 104px; */
}
.r_b a {
  display: inline-block;
  width: 112px;
  height: 46px;
  text-align: center;
  line-height: 46px;
  cursor: pointer;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  outline: none; /* 移除默认焦点边框 */
}
.r_b a:hover{
background: #e7413b !important;
color: #ffffff;
}
.r_b .isme {
  background: #e7413b;
  color: #ffffff;
}
.navigation {
  position: absolute;
    width: 1070px;
  min-height: 200px;
  /* height: 200px; */
  background-color: #fff;
  left: 0;
  top: 101px;
  /* transform: translateX(-50%); */
  /* display: flex; */
  /* justify-content: space-evenly; */
  display: none;
  border-top: 2px solid #de161e;
}
.navigation_box {
  display: flex;
justify-content: center;
    margin-left: -4px;
}
.navigation .navBox {
  /* display: flex; */
  text-align: left;
    margin: 10px 38px;
}
.navigation .navBox span {
  display: block;
  
}
.navigation .navBox a {
  display: block;
}
.navigation .navBox .navBox_title {
  color: #333333;
  font-family: PingFang SC-Bold;
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: bold;
  margin-top: 16px;
}
.navigation .navBox .navBox_son {
  color: #666666;
  font-family: PingFang SC-Regular;
  font-size: 14px;
  margin-bottom: 10px;
}
.navigation .navBox .navBox_son:hover {
  color: #de161e;
  cursor: pointer;
}
.logonImg{
  width: 190px;
}
</style>



// WEBPACK FOOTER //
// src/components/sub/topNav.vue